import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGiftBox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"gift-box, present"} maskId="square-filled-radius-0-stroke-1-IconGiftBox"><path d="M2 4H11.5V9H2V4Z" fill="currentColor"/><path d="M3 10H11.5V20H3V10Z" fill="currentColor"/><path d="M12.5 4H22V9H12.5V4Z" fill="currentColor"/><rect x="12.5" y="10" width="8.5" height="10" fill="currentColor"/></CentralIconBase>;
}));

export default IconGiftBox;
